var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 21,
    viewBox: "0 0 29 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.416667,
    y: 0.916667,
    width: 27.5,
    height: 19.1667,
    rx: 2.91667,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.416667,
    y: 0.916667,
    width: 27.5,
    height: 19.1667,
    rx: 2.91667,
    stroke: "#F2F4F7",
    strokeWidth: 0.833333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95854 13.7159H7.24209L5.95496 8.66105C5.89387 8.42853 5.76415 8.22296 5.57334 8.12607C5.09716 7.8826 4.57243 7.68883 4 7.5911V7.39648H6.76507C7.14669 7.39648 7.4329 7.68883 7.4806 8.02835L8.14844 11.6746L9.86405 7.39648H11.5328L8.95854 13.7159ZM12.4871 13.7159H10.866L12.2009 7.39648H13.8219L12.4871 13.7159ZM15.9188 9.14643C15.9665 8.80606 16.2527 8.61145 16.5866 8.61145C17.1113 8.56259 17.6829 8.66032 18.1599 8.90295L18.4462 7.54234C17.9691 7.34773 17.4444 7.25 16.9682 7.25C15.3949 7.25 14.25 8.12534 14.25 9.3402C14.25 10.2644 15.061 10.7497 15.6334 11.042C16.2527 11.3335 16.4912 11.5281 16.4435 11.8196C16.4435 12.2569 15.9665 12.4515 15.4903 12.4515C14.9179 12.4515 14.3454 12.3057 13.8215 12.0623L13.5353 13.4237C14.1077 13.6663 14.727 13.7641 15.2995 13.7641C17.0636 13.8121 18.1599 12.9376 18.1599 11.625C18.1599 9.97206 15.9188 9.87518 15.9188 9.14643ZM23.8331 13.7159L22.546 7.39648H21.1634C20.8772 7.39648 20.591 7.5911 20.4956 7.8826L18.1121 13.7159H19.7809L20.114 12.7926H22.1643L22.3551 13.7159H23.8331ZM21.4024 9.09733L21.8786 11.479H20.5438L21.4024 9.09733Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCardIcon);
export default __webpack_public_path__ + "static/media/visaCardIcon.c7f8983be9047a024895a62db83d754e.svg";
export { ForwardRef as ReactComponent };